import { TodoAssignmentContent } from '@endpoint/endpoint-bff-graphql-schema';

export const getAnswersFromStepContent = (answerKeys: string[], stepContent: TodoAssignmentContent[]) => {
  return Object.fromEntries(
    stepContent
      .filter((content) => (content?.field?.id ? answerKeys.indexOf(content.field.id) !== -1 : false))
      .map((content) => [content?.field?.id, content?.field?.answer]),
  );
};
